import { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import { getCompaniesList, getUserData } from 'store/me/selectors'
import { useUserDataForRoutes } from 'utils/hooks/useSelectedCompany'
import { Roles } from 'utils/consts/userRoles'
import { isLogin } from 'utils/token'
import { ACCOUNT_SETUP_PATH, CAPTURED_WINES_PATH } from 'utils/consts/path'
import { useLoadUserData } from 'components/Common/Menu/_methods/useLoadUserData'

const UserRedirect: FC = () => {
  useLoadUserData()
  const { role } = useUserDataForRoutes()
  const userData = useAppSelector(getUserData)
  const companies = useAppSelector(getCompaniesList)
  const hasNoCompanies = companies.length === 0

  // Redirect to login if user is not logged in
  if (!isLogin()) {
    return <Navigate to='/acc/login' replace />
  }

  // Don't redirect if coming from onboarding completion
  const fromOnboarding = sessionStorage.getItem('fromOnboarding')
  if (fromOnboarding === 'true') {
    sessionStorage.removeItem('fromOnboarding')
  }

  // Wait for user data to load before redirecting
  if (!userData?.id) return null

  // Redirect to account setup if user has no companies
  if (role === Roles.PERSON && hasNoCompanies) {
    return <Navigate to={ACCOUNT_SETUP_PATH} replace />
  }

  let newPage = '/acc/home-page'

  switch (role) {
    case Roles.PERSON: {
      newPage = CAPTURED_WINES_PATH
      break
    }
    case Roles.SUPERADMIN: {
      newPage = '/acc/home-page'
      break
    }
    case Roles.ADMIN: {
      newPage = '/acc/administration'
      break
    }
    case Roles.CONTENT: {
      newPage = '/acc/database/wines'
      break
    }
    case Roles.MANAGER: {
      newPage = '/acc/database/wines'
    }
  }

  return <Navigate to={newPage} replace />
}

export default UserRedirect
